export class PointCloudConfigService {
    public pointSize?: number;
    public pointSizeType?: string;
    public pointShape?: string;

    private viewer: any;

    constructor() {
        this.viewer = window.viewer;
    }

    setPointSizeType(value: any) {
        if (typeof value === 'number' && !Number.isNaN(value)) {
            if (value === Potree.PointSizeType.FIXED || value === 0) {
                this.pointSizeType = Potree.PointSizeType.FIXED;
            } else if (value === Potree.PointSizeType.ATTENUATED || value === 1) {
                /**[DESC] Set value to ADAPTIVE because removed this option **/
                this.pointSizeType = Potree.PointSizeType.ADAPTIVE;
            } else if (value === Potree.PointSizeType.ADAPTIVE || value === 2) {
                this.pointSizeType = Potree.PointSizeType.ADAPTIVE;
            }
        } else {
            const s = String(value).toUpperCase();
            if (s === '0' || s === 'FIXED') {
                this.pointSizeType = Potree.PointSizeType.FIXED;
            } else if (s === '1' || s === 'ATTENUATED') {
                /**[DESC] Set value to ADAPTIVE because removed this option **/
                this.pointSizeType = Potree.PointSizeType.ADAPTIVE;
            } else if (s === '2' || s === 'ADAPTIVE') {
                this.pointSizeType = Potree.PointSizeType.ADAPTIVE;
            }
        }

        this.viewer.dispatchEvent({
            type: 'point_size_type_changed',
            target: this.viewer,
        });
    }

    getPointSizeType() {
        return this.pointSizeType;
    }

    setPointSize(value: any) {
        if (this.pointSize !== value) {
            this.pointSize = value;
        }

        this.viewer.dispatchEvent({
            type: 'point_size_changed',
            target: this.viewer,
        });
    }

    getPointSize() {
        return this.pointSize;
    }

    setPointShape(value: string) {
        value = value.toUpperCase();
        if (value === 'SQUARE') {
            this.pointShape = Potree.PointShape.SQUARE;
        } else if (value === 'PARABOLOID') {
            this.pointShape = Potree.PointShape.PARABOLOID;
        } else if (value === 'CIRCLE') {
            this.pointShape = Potree.PointShape.CIRCLE;
        }

        this.viewer.dispatchEvent({
            type: 'point_shape_changed',
            target: this.viewer,
        });
    }

    getPointShape() {
        return this.pointShape;
    }
}
